import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { FileSpreadsheet, Download } from "lucide-react";

export default function AnnualReportCard() {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/manager/annual-report", { params: { year } }).then((r) => setData(r.data)).catch(() => {}); }, [year]);

  const download = async () => {
    try {
      const r = await api.get("/manager/annual-report", { params: { year, fmt: "csv" }, responseType: "blob" });
      const u = URL.createObjectURL(r.data); const a = document.createElement("a"); a.href = u; a.download = `tymcoach_recap_annuel_${year}.csv`; a.click(); URL.revokeObjectURL(u);
      toast.success("Récapitulatif annuel téléchargé");
    } catch { toast.error("Export impossible"); }
  };
  if (!data) return null;
  const eur = (v) => `${v.toFixed(2)} €`;
  return (
    <div className="mt-8 sc-card" data-testid="annual-report-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2"><FileSpreadsheet className="w-5 h-5 text-emerald-600" /> Récapitulatif fiscal annuel</h2>
        <div className="flex gap-2 items-center">
          <select data-testid="annual-year" value={year} onChange={(e) => setYear(Number(e.target.value))} className="border border-slate-200 rounded-xl p-2 text-sm">{data.years.map((y) => <option key={y} value={y}>{y}</option>)}</select>
          <button data-testid="annual-download" onClick={download} className="sc-btn sc-btn-emerald text-sm"><Download className="w-4 h-4" /> CSV pour le comptable</button>
        </div>
      </div>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-5 gap-2 text-sm">
        {[["Séances réglées", data.totals.sessions], ["Encaissé", eur(data.totals.gross)], ["Remboursé", eur(data.totals.refunds)], ["Net", eur(data.totals.net)], ["Remises promo", eur(data.totals.promo_discount)]].map(([l, v]) => (
          <div key={l} className="rounded-xl bg-slate-50 border border-slate-100 p-2" data-testid={`annual-${l.split(" ")[0].toLowerCase()}`}><div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div><div className="font-bold text-slate-900">{v}</div></div>
        ))}
      </div>
      <div className="mt-3 flex items-end gap-1 h-16" data-testid="annual-chart">
        {data.months.map((m) => { const max = Math.max(1, ...data.months.map((x) => x.net)); return <div key={m.month} title={`${m.month} : ${eur(m.net)}`} className="flex-1 rounded-t bg-emerald-500/80" style={{ height: `${Math.max(3, (m.net / max) * 100)}%` }} />; })}
      </div>
      <div className="flex justify-between text-[10px] text-slate-400"><span>Janv.</span><span>Déc.</span></div>
    </div>
  );
}
